import { render, staticRenderFns } from "./EventHandlerEdit.vue?vue&type=template&id=79da28eb&"
import script from "./EventHandlerEdit.vue?vue&type=script&lang=js&"
export * from "./EventHandlerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports